<input #field
       type="number"
       class="form-control"
       [ngModel]="innerValue"
       [value]="innerValue"
       (ngModelChange)="writeValue($event)"
       [max]="9999999999"
       step="1"
       (blur)="onTouched()">
